<template>
  <div class="mx-auto col-md-10 mt-15 mb-15">
    <el-card class="box-card" shadow="always">
      <div class="row document-upload">
        <div class="col-sm-12">
          <h2>Import ACSA Orders with Microsoft Excel</h2>
          <h6 class="sub-heading-import">
            Please follow the instructions below when utilizing the 'Import from
            Excel' service
          </h6>
          <ul>
            <li>
              <a
                href="#"
                @click.prevent="
                  downloadSampleTemplate(
                    `/api/orderreports/acsatemplate`,
                    'AGATRS_Import.xlsx'
                  )
                "
                >Please click here to Download ACSA Orders Template</a
              >
            </li>
            <li>
              Utilize the ACSA Orders template to populate your draft ACSA order
              data
            </li>
            <li>
              Validate Column A - 'Requisition Number' group all line items
              within an Order (ex Order_0001). When beginnning a new order,
              ensure you utilize the next number in sequence (i.e Order_0002).
              Further clarification available for reference on the 'instruction'
              tab
            </li>
            <li>
              Once all ACSA order data has been entered into the template, save
              the file to your workstation.
            </li>
            <li>
              Upload the saved ACSA order template file by clicking the
              <strong>"Choose File"</strong>
              button below.
            </li>
            <li>Select the file from your workstation then click 'Upload'</li>
            <li>
              Once uploaded, please view the confirmation status then click
              'View' to review your draft AGATRS order.
            </li>
            <li>
              Imported ACSA Orders are available for edit and submission once
              you return to the AGATRS 'My Orders' page.
            </li>
          </ul>
        </div>
      </div>
    </el-card>

    <el-card class="box-card mt-15" shadow="always">
      <div>
        <div class="col-sm-6">
          <p>Select File</p>
          <div class="pt-20">
            <div id="upload_button">
              <label class="browse-file-label">
                <input
                  type="file"
                  id="file"
                  ref="file"
                  @change="handleFileUpload()"
                />
                <span
                  class="btn btn-dark float-sm-none float-md-left btn-default"
                  >Choose File</span
                >
              </label>
            </div>
            <div v-show="isFileSelected">
              {{ form.file ? form.file.name : "No File Selected" }}
            </div>
            <div class="el-upload__tip" slot="tip">
              <strong>
                <small
                  >*Only "XLSX" ACSA_Import Template File</small
                >
              </strong>
            </div>
          </div>
          <div>
            <base-button type="primary" @click="submitDocument()">
              <span><i class="tim-icons icon-cloud-upload-94"></i> Upload</span>
            </base-button>
          </div>
        </div>
      </div>
    </el-card>

    <el-card class="box-card mt-15" shadow="always">
      <div>
        <div class="col-sm-12">
          <h2>Imported ACSA Orders</h2>
          <el-table :data="results" role="table"
        aria-label="Import ACSA Table">
            <el-table-column :min-width="120" align="left" label="Actions">
              <div slot-scope="props" class="table-actions">
                <el-tooltip
                  content="View"
                  :open-delay="300"
                  effect="light"
                  placement="top"
                >
                  <router-link
                    :to="`/order/view/${props.row.orderId}`"
                    class="btn-link btn-primary"
                  >
                    <i class="tim-icons icon-zoom-split"></i>
                    <span class="hide-if-small-screensize">View</span>
                  </router-link>
                </el-tooltip>
              </div>
            </el-table-column>

            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :formatter="column.formatter"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "@/axios";
import Utility from "@/mixins/utility/utility";
import {
  Upload,
  Button,
  Form,
  FormItem,
  Divider,
  Card,
  Table,
  TableColumn,
} from "element-ui";
import Util from "@/util/util";

export default {
  name: "ImportACSA",
  mixins: [Utility],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Card.name]: Card,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Divider.name]: Divider,
  },
  data() {
    return {
      form: {
        file: null,
      },
      tableColumns: [
        {
          prop: "orderId",
          label: "Order ID",
          minWidth: 100,
          scope:"col"
        },
        {
          prop: "lineItemCount",
          label: "# of LineItem",
          minWidth: 150,
          scope:"col"
        },
        {
          prop: "totalValue",
          label: "Valued",
          minWidth: 100,
          scope:"col"
        },
        {
          prop: "fileName",
          label: "File Name",
          minWidth: 120,
          scope:"col"
        },
        {
          prop: "status",
          label: "Status",
          minWidth: 100,
          scope:"col"
        },
        {
          prop: "errorException",
          label: "Failed Reason",
          minWidth: 200,
          scope:"col"
        },
      ],
      results: [],
    };
  },
  computed: {
    isFileSelected() {
      return this.form.file ? true : false;
    },
  },
  methods: {
    downloadSampleTemplate(url, title) {
      let ctx = this;
      axios({
        url: url,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        Util.fileDownload(response.data, title);
      });
    },
    handleFileUpload() {
      const uploadedForm = this.$refs.file.files[0];

      this.form.file = this.$refs.file.files[0];
    },
    async submitDocument() {
      let ctx = this;
      let formData = new FormData();
      formData.append("file", ctx.form.file);

     await axios
        .post("/api/orderreports/import", formData)
        .then((response) => (ctx.results = response.data))
        .catch((err) => {
          this.$toast.error(err.response.data);
        });
    },
  },
};
</script>

<style scoped>
span.btn.btn-outline {
  background: #f3f3f3 !important;
  border: 1px solid grey;
  color: darkgrey;
  height: 10px;
  line-height: 0;
}

#upload_button {
  display: inline-block;
}

#upload_button input[type="file"] {
  display: none;
}

.sub-heading-import {
  text-transform: none;
}

.mt-15 {
  margin-top: 15px;
}

.mb-15 {
  margin-bottom: 15px;
}

.pb-20 {
  padding-bottom: 20px;
}

.browse-file-label {
  margin-bottom: 0 !important;
}

.divider-green {
  background-color: #10b45a;
  width: 80%;
  text-align: center;
  margin: auto;
}
</style>
